package gr.tech.GRAttestation.models.attestation

import kotlinx.serialization.Serializable

@Serializable
data class SubmitAttestationForm(
    val reportingMonth: String,
    val salesData: List<SalesData>,
    val repName: String,
    val repSignDate : String,
    val acceptedTerms: Boolean,
)